import React, {useEffect} from 'react';
import { Button, Card, CardBody, CardText, CardTitle, Col, Container, Row, Icon } from 'design-react-kit';
import { useNavigate } from 'react-router-dom';
import {properties} from "../../config/properties";

function Dashboard({user}) {
    const navigate = useNavigate();


    // Funzione per navigare alla ricerca delle persone
    const handleCercaPersonaClick = () => {
        navigate('/private/ricercaSpecimen');
    };

    // Funzione per navigare alla lista specimen (ho ipotizzato un percorso)
    const handleListaSpecimenClick = () => {
        // Aggiorna questo percorso se è diverso
        navigate('/private/ricercaListaSpecimen');
    };

    return (

        <Container className={"py-lg-5"}>

            <div className="bg-white py-5 py-lg-6">
                {/* Sezione di Benvenuto */}
                <Container className="text-left mb-5">
                    <h2 className="mb-1">
                        Benvenuto, {user?.userID || 'Utente'}!
                    </h2>
                    <p className="lead text-secondary">
                        Seleziona una delle operazioni disponibili per iniziare.
                    </p>
                </Container>

                {/* Sezione con le Card Azione */}
                <Container>
                    <Row>

                        {/* Card 1: Cerca Persona */}
                        <Col md={6} lg={6} className="mb-4">
                            <Card className="h-100 text-center shadow-sm border-0 p-3 card-hover">
                                <CardBody className="d-flex flex-column">
                                    <Icon
                                        icon="it-search"
                                        color="primary"
                                        size="xl"
                                        className="mx-auto mb-3"
                                        aria-hidden
                                    />
                                    <CardTitle tag="h2" className="h4 text-primary">
                                        Cerca Persone
                                    </CardTitle>
                                    <CardText className="lead text-secondary flex-grow-1 mb-4">
                                        Trova rapidamente persone registrate nel servizio Specimen in tutte le Camere di
                                        Commercio aderenti.
                                    </CardText>
                                    <Button color={"primary"} onClick={handleCercaPersonaClick}>
                                        Avvia Ricerca
                                    </Button>
                                </CardBody>
                            </Card>
                        </Col>


                        {/* Card 2: Lista Specimen */}
                        <Col md={6} lg={6} className="mb-4">
                            <Card className="h-100 text-center shadow-sm border-0 p-3 card-hover">
                                <CardBody className="d-flex flex-column">
                                    <Icon
                                        icon="it-list"
                                        cclassName="btn btn-outline-primary"
                                        size="xl"
                                        className="mx-auto mb-3"
                                        aria-hidden
                                    />
                                    <CardTitle tag="h2" className="h4 text-primary">
                                        Liste Specimen
                                    </CardTitle>
                                    <CardText className="lead text-secondary flex-grow-1 mb-4">
                                        Consulta e stampa la lista specimen ufficiale di una specifica Camera di
                                        Commercio.
                                    </CardText>
                                    <Button color="primary" outline onClick={handleListaSpecimenClick}>
                                        Vai alle Liste
                                    </Button>
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>

        </Container>

    );
}


export default Dashboard;